import React from "react";
import PropTypes from "prop-types";
import cl from "classnames";
import classes from "./styles.module.scss";

const VenueTypeOption = ({
  name,
  value,
  onChange,
  checked,
  gaPrefix,
  blue = false,
}) => {
  const id = `venueTypeOption-${value}`;
  return (
    <label
      htmlFor={id}
      className={cl(classes.VenueTypeOption, {
        [classes.checked]: checked,
        [classes.blue]: blue,
      })}
      data-ga={gaPrefix && `${gaPrefix}-${value.toLowerCase()}`}
    >
      {name}
      <input
        id={id}
        type="checkbox"
        name="venueTypeOption"
        value={value}
        onChange={({ currentTarget }) => onChange(value, currentTarget.checked)}
        checked={checked}
      />
    </label>
  );
};

VenueTypeOption.propTypes = {
  name: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  checked: PropTypes.bool.isRequired,
  gaPrefix: PropTypes.string,
  blue: PropTypes.bool,
};

export default VenueTypeOption;
